import styled, { css } from "styled-components";

const SelectStyled = styled.div`
    label {
        display: none;
    }
    /* focused */
    ${props => {
        return (
            props.focused &&
            css`
                label {
                    font-size: 1.2rem;
                    top: 1.5rem;
                    font-weight: bold;
                    display: block;
                }
                select {
                    line-height: normal; /* safari fix */
                    padding-top: 2rem;
                    padding-bottom: 0;
                    padding-right: 2rem;
                }
            `
        );
    }}
`;

export default SelectStyled;
